import script from "./BillingSubscribeButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./BillingSubscribeButton.vue?vue&type=script&setup=true&lang=ts"

import "./BillingSubscribeButton.vue?vue&type=style&index=0&id=9633795e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9633795e"]])

export default __exports__